import { queryOptions, useQuery } from '@tanstack/react-query';

import { ApiResponse, QueryOptions } from '@cast/shared-types';

import { apiClient } from '@cast/infrastructure-api';

const apiFn = apiClient.dbo.getProxyConnectionsMetrics;

export type ProxyConnectionsMetricsResponse = ApiResponse<typeof apiFn>;

const PROXY_CONNECTIONS_METRICS_QUERY_KEY = 'dbo-proxy-connections-metrics';

const getProxyConnectionsMetricsQueryKey = (
  params: Parameters<typeof apiFn>[0]
) => [PROXY_CONNECTIONS_METRICS_QUERY_KEY, params] as const;

export const useProxyConnectionsMetricsQuery = <
  SELECT = ProxyConnectionsMetricsResponse
>(
  params: Parameters<typeof apiFn>[0],
  options?: QueryOptions<ProxyConnectionsMetricsResponse, SELECT>
) =>
  useQuery(
    queryOptions({
      queryKey: getProxyConnectionsMetricsQueryKey(params),
      queryFn: async () => {
        const { data } = await apiFn(params);
        return data;
      },
      ...options,
    })
  );
